import { ServiceType } from "@/types";
import { ConfigKeys } from "./constants";
import readConfigurationProperty from "./readConfigurationProperty";

export function hasGroupBooking(service: ServiceType): boolean {
    return (
        service.GroupBooking.Active && service.GroupBooking.Min !== service.GroupBooking.Max
    );
}

export function hasMultipleResources(service: ServiceType): boolean {
    return (
        service.MultipleResource.Active &&
        service.MultipleResource.Min !== service.MultipleResource.Max
    );
}

export const getXlanguageCode = () => {
    if (readConfigurationProperty(ConfigKeys.LANGUAGE) === "no") {
        return 'nb-no';
    }

    return readConfigurationProperty(ConfigKeys.LANGUAGE) || "sv"
}
